import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.667 9a8.333 8.333 0 1116.666 0A8.333 8.333 0 11.667 9zm9.166-3.333a.833.833 0 10-1.666 0 .833.833 0 001.666 0zM9 13.167a.833.833 0 00.833-.834V9a.833.833 0 00-1.666 0v3.333a.833.833 0 00.833.834z"
        fill="#FF7A00"
      />
    </Svg>
  );
}

export default SvgComponent;
